import { ArrowsDownUp, Check } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import type { TemplateType } from "common/types";

import {
  TEMPLATE_SORTING_ORDERS,
  TEMPLATE_TYPE_SORTING_ORDERS,
} from "../../constants";

export default function FiltersDropdown({
  templateType,
  sortOrder,
  setSortOrder,
}: {
  templateType: TemplateType;
  sortOrder: keyof typeof TEMPLATE_SORTING_ORDERS;
  setSortOrder: (key: keyof typeof TEMPLATE_SORTING_ORDERS) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline-black" intent="iconOnly">
          <ArrowsDownUp />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuList>
          {TEMPLATE_TYPE_SORTING_ORDERS[templateType].map((key) => {
            const { label } = TEMPLATE_SORTING_ORDERS[key];
            return (
              <DropdownMenuItem key={key} onSelect={() => setSortOrder(key)}>
                {label}
                {sortOrder === key && <Check className="ml-auto size-5" />}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
